import { render, staticRenderFns } from "./LawDetail.vue?vue&type=template&id=5e094a54&scoped=true"
import script from "./LawDetail.vue?vue&type=script&lang=js"
export * from "./LawDetail.vue?vue&type=script&lang=js"
import style0 from "./LawDetail.vue?vue&type=style&index=0&id=5e094a54&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e094a54",
  null
  
)

export default component.exports